import { render, staticRenderFns } from "./LaundryItemAdd.vue?vue&type=template&id=731a490d&scoped=true"
import script from "./LaundryItemAdd.vue?vue&type=script&lang=js"
export * from "./LaundryItemAdd.vue?vue&type=script&lang=js"
import style0 from "./LaundryItemAdd.vue?vue&type=style&index=0&id=731a490d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731a490d",
  null
  
)

export default component.exports